// Storage key for the per-trade social preview card. Browser and server safe.
export function caseStudyCardKey(id: string): string {
  return id.replace(/[^A-Za-z0-9-]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 160) || "card";
}
